import { NATIVE_APP_REDIRECT_URI } from '../config';

export function getNativeAppRedirectUrl(params: Record<string, string>): string {
  const base = NATIVE_APP_REDIRECT_URI || '';
  if (!base) return '';
  const query = new URLSearchParams(params).toString();
  return `${base}?${query}`;
}

export function getLogoutRedirectUrl(): string {
  return getNativeAppRedirectUrl({ logout: 'logoutButtonClick' });
}

export function getForgotPasswordRedirectUrl(): string {
  return getNativeAppRedirectUrl({ loginError: 'FUPLinkClick' });
}

export function getRegisterRedirectUrl(): string {
  return getNativeAppRedirectUrl({ loginError: 'registrationLinkClick' });
}
